// extracted by mini-css-extract-plugin
module.exports = {"prices":"_135UO","outOfStock":"_3VcaF","priceBeforeDiscount":"_1ejFH","priceToPay":"_2wyxs"};